export default "__VITE_ASSET__CkyMuWMA__"